import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";

// Componentes
import Header from "./components/Header";
import Footer from "./components/Footer";

// Views
import ProductsView from "./views/ProductsView"; // <-- importa tu nueva vista
import ProductDetail from "./views/ProductDetail";
import LoginView from "./views/LoginView";
import CartView from "./views/CartView";
import OrdersView from "./views/OrdersView";
import OrderRegistration from "./views/OrderRegistration";
import ConfirmationOrder from "./views/ConfirmationOrder";
import InitialPayment from "./views/InitialPayment";
import PickupInfo from "./views/PickupInfo";
import OrderStatus from "./views/OrderStatus";

function App() {
  return (
    <CartProvider>
      <Router>
        {/* Header siempre visible */}
        <Header />

        {/* Rutas */}
        <Routes>
          {/* Home: muestra todos los productos */}
          <Route path="/" element={<ProductsView />} />

          {/* Categorías */}
          <Route path="/hombres" element={<ProductsView categoria="hombres" />} />
          <Route path="/mujeres" element={<ProductsView categoria="mujeres" />} />
          <Route path="/accesorios" element={<ProductsView categoria="accesorios" />} />
          <Route path="/ofertas" element={<ProductsView categoria="ofertas" />} />
          {/* demás rutas */}

          {/* Otros flujos */}
          <Route path="/producto/:id" element={<ProductDetail />} />
          <Route path="/login" element={<LoginView />} />
          <Route path="/carrito" element={<CartView />} />
          <Route path="/mis-compras" element={<OrdersView />} />
          <Route path="/registro-ordenes" element={<OrderRegistration />} />
          <Route path="/confirmacion-pedido" element={<ConfirmationOrder />} />
          <Route path="/pago-inicial" element={<InitialPayment />} />
          <Route path="/recogida-producto" element={<PickupInfo />} />
          <Route path="/orden-estado" element={<OrderStatus />} />
        </Routes>

        {/* Footer siempre visible */}
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
